import { Component, inject } from '@angular/core';
import { AdminStammdatenImportgrundEntryComponent } from '@app/admin/stammdaten/importgrund/admin-stammdaten-importgrund-entry/admin-stammdaten-importgrund-entry.component';
import { AdminStammdatenImportgrundNewComponent } from '@app/admin/stammdaten/importgrund/admin-stammdaten-importgrund-new/admin-stammdaten-importgrund-new.component';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe } from '@ngx-translate/core';
import { rxResource } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-admin-stammdaten-importgrund',
  templateUrl: './admin-stammdaten-importgrund.component.html',
  imports: [
    AdminStammdatenImportgrundEntryComponent,
    AdminStammdatenImportgrundNewComponent,
    TranslatePipe,
  ],
})
export class AdminStammdatenImportgrundComponent {
  private readonly backendService = inject(BackendService);

  protected readonly gruende = rxResource({ defaultValue: [], stream: () => this.backendService.listImportGruendeAdmin() });

  onGrundDeleted(id: number) {
    this.gruende.update( list =>
      list.filter( grund => grund.id !== id )
    )
  }
}
